import styled from 'styled-components';
import Copyright from '../Copyright';

const FooterContainer = styled.div({
    padding: '24px',
});

interface FooterProps {
    version: string;
    organizationLegalName: string;
}
const Footer = ({ version, organizationLegalName }: FooterProps) => (
    <FooterContainer>
        <Copyright organizationLegalName={organizationLegalName} version={version} />
    </FooterContainer>
);

export default Footer;
